// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Saut","productName":"Table_productName__gyOht"};